import React from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import CustomTextField from '../inputs/CustomTextField';
import PhoneInput from '../inputs/PhoneInput';
import SocialButtons from '../inputs/SocialButtons';
import apiClient from '../../api/apiClient';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const StepForm = ({
  formData,
  currentStep,
  handleChange,
  handleSocialChange,
  nextStep,
  prevStep,
  totalSteps
}) => {
  const handleSubmit = async () => {
    if (currentStep === totalSteps - 1) {
      try {
        // Format phone number with country code for India
        const submissionData = {
          ...formData,
          phoneNumber: formData.phoneNumber ? `+91${formData.phoneNumber}` : '',
        };
        console.log("submission",submissionData)
        const response = await apiClient.post('/', submissionData);
        console.log('Submission successful:', response.data);
        // Here you could add success notification or redirect
      } catch (error) {
        console.error('Submission error:', error);
        // Here you could add error handling
      }
    } else {
      nextStep();
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              What's your full name?
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              As it appears on your business card or your LinkedIn profile.
            </Typography>
            <CustomTextField
              value={formData.fullName}
              onChange={(e) => handleChange('fullName', e.target.value)}
              aria-label="Full name"
            />
          </>
        );
      case 1:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              What's your current designation?
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              Your role. Bonus points if it sounds impressive at dinner parties.
            </Typography>
            <CustomTextField
              value={formData.designation}
              onChange={(e) => handleChange('designation', e.target.value)}
              aria-label="Designation"
            />
          </>
        );
      case 2:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              What's your company name?
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              The organization you represent. If you're flying solo, your name works too!
            </Typography>
            <CustomTextField
              value={formData.companyName}
              onChange={(e) => handleChange('companyName', e.target.value)}
              aria-label="Company name"
            />
          </>
        );
      case 3:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              What's your email address?
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              We promise not to spam you. Unless you're into that.
            </Typography>
            <CustomTextField
              type="email"
              value={formData.email}
              onChange={(e) => handleChange('email', e.target.value)}
              aria-label="Email address"
            />
          </>
        );
      case 4:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              What's your phone number?
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              Only to build your network, so they can reach out without stalking you on LinkedIn.
            </Typography>
            <PhoneInput
              value={formData.phoneNumber}
              onChange={handleChange}
            />
          </>
        );
      case 5:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              Let's get those socials
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              So your new connections can keep in touch professionally.
            </Typography>
            <SocialButtons
              socials={formData.socials}
              handleSocialChange={handleSocialChange}
            />
          </>
        );
      case 6:
        return (
          <>
            <Typography textAlign="center"  variant="h5" component="h1" gutterBottom>
              Can you write yourself a short bio?
            </Typography>
            <Typography textAlign="center" variant="body2" mb={4} color="text.secondary" gutterBottom>
              A quick intro. Think: "I help businesses grow" or "I design things that work."
            </Typography>
            <CustomTextField
              value={formData.bio}
              onChange={(e) => handleChange('bio', e.target.value)}
              multiline
              rows={4}
              aria-label="Bio"
            />
          </>
        );
      default:
        return null;
    }
  };

  const isStepValid = () => {
    switch (currentStep) {
      case 0:
        return formData.fullName.trim() !== '';
      case 1:
        return formData.designation.trim() !== '';
      case 2:
        return formData.companyName.trim() !== '';
      case 3:
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
      case 4:
        return formData.phoneNumber.length === 10;
      case 5:
        return true; // Socials are optional
      case 6:
        return formData.bio.trim() !== '';
      default:
        return false;
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={10} md={8} lg={8}>
        <Paper 
          elevation={0}
          sx={{
            padding: 4,
            borderRadius: 2,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            border: '1px solid rgba(255, 255, 255, 0.18)',
            maxWidth: '450px',
            margin: '0 auto',
          }}
        >
          <Box sx={{ mb: 2 }}>
            {renderStepContent()}
          </Box>
          
          {currentStep > 0 ? (
            <Grid container>
              {/* <Grid item xs={2} my="auto" py="auto">
                <Button
                      fullWidth
                      variant="text"
                      onClick={prevStep}
                      sx={{ 
                        my: "auto",
                        py: "auto",
                        color: 'white',
                      }}
                  >
                    <ArrowBackIcon /> 
                </Button>
              </Grid> */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSubmit}
                  disabled={!isStepValid()}
                  sx={{ 
                    background: (theme) => theme.gradients.whiteButton,
                    color: '#00BCD4',
                    fontWeight: 'semibold',
                    padding: '0.75rem',
                    fontSize: '1rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.0755rem',
                    '&:hover': {
                      background: (theme) => theme.gradients.whiteButton,
                      boxShadow: '0 0.25rem 1.25rem 0 rgba(0, 0, 0, 0.2)',
                      opacity: 0.9
                    },
                    '&.Mui-disabled': {
                      background: 'rgba(255, 255, 255, 0.1)',
                      color: 'rgba(255, 255, 255, 0.3)'
                    }
                  }}
                >
                  {currentStep === totalSteps - 1 ? 'Submit' : 'CONTINUE'}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={!isStepValid()}
              sx={{ 
                background: (theme) => theme.gradients.whiteButton,
                color: '#00BCD4',
                fontWeight: 'semibold',
                width: '100%',
                padding: '0.75rem',
                fontSize: '1rem',
                textTransform: 'uppercase',
                letterSpacing: '0.0755rem',
                '&:hover': {
                  background: (theme) => theme.gradients.whiteButton,
                  boxShadow: '0 0.25rem 1.25rem 0 rgba(0, 0, 0, 0.2)',
                  opacity: 0.9
                },
                '&.Mui-disabled': {
                  background: 'rgba(255, 255, 255, 0.1)',
                  color: 'rgba(255, 255, 255, 0.3)'
                }
              }}
            >
              Continue
            </Button>
          )}


        </Paper>
      </Grid>
    </Grid>
  );
};

export default StepForm;